<div class="dashboard-progress res-assign-block" fxFlex="0 1 100%">
    <app-sticky-header
        class="sticky-header"
        context="Welcome page material"
        title="Select material for welcome page"
        contextIcon="rocket_launch"
    ></app-sticky-header>
    <!-- <app-resource-select
        selectionLabel="Number of materials"
        [scope_id]="AppScope.MATERIAL"
        [customer_id]="data.customer_id"
        [accessForm]="resourceForm"
        [referenceFilter]="referenceProperty"
        i18n-selectionLabel
        [sync_all_key]="sync_all_key"
        [attachKey]="attachKey"
        [detachKey]="detachKey"
        [singleSelect]="true"
    ></app-resource-select> -->
    <app-resource-table-base
        #tableBase
        matSortActive="updated_at"
        [columnsData]="columnsData"
        [columnsKeys]="columnsKeys"
        [otherContext]="otherContext"
        [expandingTable]="false"
        [filter]="filter"
        [tableFilterItems]="[
            { property: 'availableForCustomer', items: [customer.id] },
            {
                property: 'scope',
                items: [AppScope.MATERIAL]
            }
        ]"
        [pageSizeOptions]="pageSizeOptions"
        [disabledRows]="customer.metadata?.welcome_material?.ids"
        (rowClick)="bottomSheetRef.dismiss($event)"
    >
        <ng-container tableFiltersTempl>
            <app-table-filter
                [filtersTogglesInOnBtn]="true"
                [defaultFilter]="GlobalFilterProperty.SEARCH"
                [inGlobalFilter]="true"
                color="accent"
                #filter
            >
                <app-table-search
                    toggleBtnLabel="Schema"
                    i18n-toggleBtnLabel
                    [inGlobalFilter]="true"
                    class="align-space"
                    searchFilterRef
                ></app-table-search>
                <app-table-date-filter [inGlobalFilter]="true" color="accent" deadlineFilterRef></app-table-date-filter>

                <app-tag-chip-search-filter
                    [inGlobalFilter]="true"
                    fxFlex="50%"
                    fxFlex.lt-md="100%"
                    fxLayoutAlign="start"
                    tagsFilterRef
                ></app-tag-chip-search-filter>
            </app-table-filter>
        </ng-container>
    </app-resource-table-base>
    <ng-template #img let-resource>
        <app-image-view
            [media_id]="resource.media$"
            [proportional]="true"
            [paddingBottom]="'58px'"
            [smallSpinner]="true"
        ></app-image-view>
    </ng-template>
    <ng-template #title let-resource>
        <ng-container *ngIf="!(isMobile$ | async)">
            <span> {{ resource.title }}</span>
        </ng-container>
        <ng-container *ngIf="isMobile$ | async">
            <div fxLayout="row" fxLayoutGap="5px" class="w-100" fxLayoutAlign="start start">
                <app-image-view
                    [media_id]="resource.media$"
                    [proportional]="true"
                    [paddingBottom]="'50px'"
                    [smallSpinner]="true"
                ></app-image-view>
                <span class="res-title" fxFlex="grow"> {{ resource.title }}</span>
            </div>
        </ng-container>
    </ng-template>
    <ng-template #updated_at let-resource>
        <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@updatedAt">Updated at: </span>
        <span>{{ resource.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }} </span>
    </ng-template>
    <ng-template #tools let-resource>
        <div class="tools-cell-wrapper">
            <button
                (click)="$event.stopPropagation(); bottomSheetRef.dismiss(resource)"
                matTooltip="Select"
                mat-icon-button
                i18n-matTooltip="@@select"
                class="select-btn"
            >
                <mat-icon>check_circle</mat-icon>
            </button>
        </div>
    </ng-template>
</div>
